import React, { useContext } from "react";
import {
  makeStyles,
  Container,
  Grid,
  Typography,
  Divider,
} from "@material-ui/core";
import CardComponent from "./CardComponent";
import QuoteImage from "../../assets/quote.png";
import { GeneralContext } from "../../contexts/GeneralContext";

const useStyles = makeStyles((theme) => ({
  heading: {
    marginTop: "5vh",
    letterSpacing: "1px",
    color: "#383838",
  },
  divider: {
    height: "6px",
    width: "20%",
    margin: "1rem auto 2rem auto",
    background: "linear-gradient(to right, #ffff00 0%, #33cc33 100%)",
  },
}));

function Testimonial(props) {
  const classes = useStyles();
  const [info] = useContext(GeneralContext);
  const { testimonials } = info;
  const content = testimonials.map((testimonial) => (
    <CardComponent key={testimonial.id} img={QuoteImage} {...testimonial} />
  ));
  return (
    <Container maxWidth="lg">
      <Typography className={classes.heading} variant="h3" align="center">
        TESTIMONIALS
      </Typography>
      <Divider className={classes.divider} variant="fullWidth" />
      <Grid container alignItems="center" justify="center">
        {content}
      </Grid>
    </Container>
  );
}

export default Testimonial;
